import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { THEME_COLORS } from "../../themes/DarkLight";
import useThemeHook from "../../hooks/useThemeHook";
import PageView from "../../components/PageView";
import CommonNavBar from "../../components/CommonNavBar";
import Text from "../../components/ThemedText";
import { FONTSIZE } from "../../../constants";
import { useTranslationHook } from "../../hooks/useTranslationHook";
import {
  ArrowUp,
  ArrowDown,
  SwapHorizontalOutline,
  LayersOutline,
  WalletOutline,
} from "react-ionicons";
import { PAGE_NAME } from "../../../types";

export default function CryptoViewPage() {
  const location = useLocation();
  const crypto = location?.state?.crypto;

  // Function to format dates
  const formatDate = (dateString: any) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    return date?.toLocaleDateString();
  };

  // Function to format percentages
  const formatPercentage = (value: any) => {
    if (value === null) return "";
    return `${value?.toFixed(2)}%`;
  };

  // Function to format numbers with commas
  const formatNumber = (value: any) => {
    if (value === null) return "";
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };
  const theme = useThemeHook();
  const getTranslationText = useTranslationHook();
  const navigate = useNavigate();

  const onOptionPress = (path: string) =>
    navigate(path, {
      state: { crypto: crypto },
    });
  const options = [
    {
      onPress: () => onOptionPress(PAGE_NAME.SEND_CRYPTO),
      id: 1,
      iconName: (
        <ArrowUp
          height={FONTSIZE.SECONDARY}
          width={FONTSIZE.SECONDARY}
          color={THEME_COLORS[theme].gray}
        />
      ),
      title: getTranslationText("send"),
    },
    {
      onPress: () => onOptionPress(PAGE_NAME.RECEIVE_CRYPTO),
      id: 2,
      iconName: (
        <ArrowDown
          height={FONTSIZE.SECONDARY}
          width={FONTSIZE.SECONDARY}
          color={THEME_COLORS[theme].gray}
        />
      ),
      title: getTranslationText("receive"),
    },
    // {
    //   onPress: () => onOptionPress(PAGE_NAME.SWAP),
    //   id: 3,
    //   iconName: (
    //     <SwapHorizontalOutline
    //       height={FONTSIZE.SECONDARY}
    //       width={FONTSIZE.SECONDARY}
    //       color={THEME_COLORS[theme].gray}
    //     />
    //   ),
    //   title: getTranslationText("swap"),
    // },
    {
      onPress: () => onOptionPress(PAGE_NAME.DEPOSIT),
      id: 4,
      iconName: (
        <WalletOutline
          height={FONTSIZE.SECONDARY}
          width={FONTSIZE.SECONDARY}
          color={THEME_COLORS[theme].gray}
        />
      ),
      title: getTranslationText("deposit"),
    },
  ];
  return (
    <PageView>
      <CommonNavBar />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "20px",
        }}
      >
        <img
          src={crypto?.image}
          alt={crypto?.name}
          style={{
            maxWidth: "150px",
            maxHeight: "150px",
            borderRadius: "100%",
            objectFit: "cover",
          }}
        />
        <Text
          text={(crypto?.balance ?? 0) + " " + crypto?.name}
          style={{
            textAlign: "center",
            fontWeight: "500",
            fontSize: FONTSIZE.PRIMARY,
            marginBottom: "2px",
          }}
        />
        <Text
          text={(crypto?.balance ?? 0) * crypto?.current_price + " $"}
          style={{
            color: THEME_COLORS[theme].gray,
            textAlign: "center",
            fontWeight: "500",
            fontSize: FONTSIZE.TERTIARY,
            marginBottom: "20px",
          }}
        />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          width: "100%",
          justifyContent: "space-between",
          marginBottom: "10px",
          backgroundColor: THEME_COLORS[theme].component_background_color,
          borderRadius: "20px",
          padding: "10px",
        }}
      >
        {options?.map((op, index) => {
          return (
            <div
              onClick={op.onPress}
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: "55px",
                  width: "55px",
                  borderRadius: "30px",
                  backgroundColor: THEME_COLORS[theme].less_theme,
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "10px",
                }}
              >
                {op.iconName}
              </div>
              <Text
                text={op?.title}
                style={{ fontSize: FONTSIZE.QUINTERNARY }}
              />
            </div>
          );
        })}
      </div>
      <div style={{ width: "100%", height: "100px" }}></div>
    </PageView>
  );
}
